import React, { useContext } from "react";
import { LanguageContext } from "../context/LanguageContext";

export default function MainAddictionRibonMobile(props) {
  const { translate } = useContext(LanguageContext);
  return (
    <div
      className="ribon-primary-addiction-mobile"
      onClick={props.onClick}
      style={{ cursor: "pointer" }}
    >
      {props.mainAddiction
        ? props.mainAddiction === "Other"
          ? translate("PrimaryAddiction") + props.addictionOther
          : translate("PrimaryAddictionColon") + props.mainAddiction
        : translate("NoPrimaryAddictionRecorded")}
    </div>
  );
}
